import styles from "./LandingLayout.module.scss";

type LandingLayoutProps = {
  header: React.ReactNode;
  pinnedArticle?: React.ReactNode;
  editorialProject?: React.ReactNode;
  river: React.ReactNode;
  sidebar?: React.ReactNode;
  fetching?: boolean;
};

const Loading = () => (
  <div className={styles.loadingContainer}>
    <div className={styles.loadingAlert}>Loading more stories</div>
  </div>
);

const LandingLayout = ({
  header,
  pinnedArticle,
  editorialProject,
  river,
  sidebar,
  fetching,
}: LandingLayoutProps) => {
  return (
    <div className={styles.root} data-category="landing page">
      <header className={styles.header} id="main-content">
        {header}
      </header>
      <div aria-live="polite">{fetching && <Loading />}</div>
      <main className={styles.main} hidden={fetching}>
        {pinnedArticle && (
          <div className={styles.pinnedArticle}>{pinnedArticle}</div>
        )}
        {editorialProject && (
          <div className={styles.editorialProject}>{editorialProject}</div>
        )}
        {river}
      </main>
      <aside className={styles.sidebar} hidden={fetching}>
        {sidebar}
      </aside>
    </div>
  );
};
export default LandingLayout;
